// @ts-nocheck
import { useState, useEffect } from 'react';
import { initializePaddle, Paddle } from '@paddle/paddle-js';

export interface PaddleConfig {
  environment: string;
  token: string;
}

let paddleInstance: Paddle | null = null;
/**
 * A React hook that returns a Paddle instance. If `config` is null/empty or missing
 * environment/token, it does nothing until they are provided.
 */
export const usePaddle = (
  config: PaddleConfig,
  onCheckoutComplete?: (data: any) => void,
  onCheckoutClose?: () => void
): Paddle | null => {
  const [paddle, setPaddle] = useState<Paddle | null>(null);

  useEffect(() => {
    // If config is null, or environment/token are missing or empty, do nothing:
    if (!config || !config.environment || !config.token) {
      return;
    }

    // If we already have a Paddle instance, just set it; otherwise, initialize:
    if (paddleInstance) {
      setPaddle(paddleInstance);
      return;
    }

    // Initialize Paddle only once
    initializePaddle({
      eventCallback(event) {
        if (onCheckoutComplete && event.name === 'checkout.completed') {
          onCheckoutComplete?.(event.data);
        }
        if (onCheckoutClose && event.name === 'checkout.closed') {
          onCheckoutClose?.();
        }
      },
      ...config,
    })
      .then((instance) => {
        paddleInstance = instance;
        setPaddle(instance);
      })
      .catch((err) => {
        console.error('Paddle initialization failed:', err);
      });
  }, [config, onCheckoutComplete, onCheckoutClose]);

  return paddle;
};
